import React from 'react';

export const PaymentBadge: React.FC<{ method?: string }> = ({ method }) => {
    const config: Record<string, { label: string; bg: string }> = {
        promptpay: { label: 'พร้อมเพย์', bg: '#3B82F6' },
        cod: { label: 'เก็บเงินปลายทาง', bg: '#9CA3AF' },
        mobile_banking: { label: 'โอนเงิน', bg: '#86EFAC' },
        wallet: { label: 'กระเป๋าเงิน', bg: '#64748B' },
    };

    if (!method) return <span className="text-xs text-stone-400 dark:text-gray-400">-</span>;

    const { label, bg } = config[method] || { label: method, bg: '#D1D5DB' };

    return (
        <span
            className="inline-block px-2 py-0.5 text-xs font-medium text-white rounded"
            style={{ backgroundColor: bg }}
        >
            {label}
        </span>
    );
};
